import React from 'react'
import { usePopularPostsQuery } from '../../hooks/usePopularPostsQuery'
import { Carousel } from '../carousel/Carousel'
import vector from '../../images/vector.svg'
import { Link } from '../global'

import './newsSpinner.scss'

/**
 * Renders a list of news items as links.
 *
 * @param {Array} data - An array of news data.
 * @returns {JSX.Element[]} An array of JSX elements representing news items as links.
 */
const renderNewsItems = data =>
  data.map(news => (
    <Link to={news.uri} key={news.id}>
      <div className="news-container">
        <p className="title">{news.title}</p>
        <p
          className={`category ${
            news.categorySlug === 'bloggar' ? 'orange' : 'green'
          }`}
        >
          {news.category}
        </p>
      </div>
    </Link>
  ))

/**
 * A component to display popular news posts in a carousel format.
 *
 * @returns {JSX.Element} The JSX element representing the NewsSpinner component.
 */
export const NewsSpinner = () => {
  const data = usePopularPostsQuery()

  const news = renderNewsItems(data)

  return (
    <div className="news-spinner-container">
      <div className="grid-container">
        <p className="container-title">MEST LÄSTA I MÅNADEN</p>
        <div>
          <Carousel
            data={news}
            gradiant={{ show: true, color: 'white' }}
            autoPlay
          />
        </div>

        <Link className="more-articles" to="/category/alla">
          FLER ARTIKLAR <img src={vector} alt="arrow" />
        </Link>
      </div>
    </div>
  )
}
